import React,{useEffect, useState} from "react";
import ApiContext from "./services/apiContext";
import GlobalSpinnerContextProvider from "./components/loader/useloader";
import NotificationContextProvider from "./components/notificationModal/useModal";
import { NotificationModal } from "./components/notificationModal/notificationModal";
import { Loader } from "./components/loader/loader";
import Routespaths from "./routes/Routes";
import Header from "./pages/Header/Header";
import Footer from "./pages/Footer/Footer";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { AuthProvider } from "./services/authContext";
import { useLocation } from "react-router-dom";

const App = () => {


  let location = useLocation(); //to check router path
  // console.log("pageLoaded");
  const [pageurl, setPageUrl] = useState(location.pathname);
  React.useEffect(() => {
    // runs on location, i.e. route, change
    setPageUrl(location.pathname)
    
  }, [location])

  console.log(pageurl)
  return (
    <GlobalSpinnerContextProvider>
      <NotificationContextProvider>
        <AuthProvider>
          <ApiContext>
            <Loader />
            {!pageurl.includes('admin') ? <NotificationModal /> : ''}
            {pageurl !== '/refer-earn' && !pageurl.includes('admin') ? <Header /> : ''}
            <Routespaths />
            {!pageurl.includes('admin') ? <Footer pageurl={pageurl} /> : ''}
            {/* { removeChatInAdmin() } */}
          </ApiContext>
        </AuthProvider>
      </NotificationContextProvider>
    </GlobalSpinnerContextProvider>
    )  
};

export default App;
